import { IntlProvider } from 'react-intl';
import { LOCALE } from '../data/constants';
import { useMessages } from '../hooks/useMessages';
import { StyledMainContent } from './App.styles';
import { WidgetContainer } from './organisms/WidgetContainer/WidgetContainer';

export default function App(): JSX.Element | null {
  const messages = useMessages();

  if (!messages) {
    return null;
  }

  return (
    <>
      <IntlProvider locale={LOCALE} defaultLocale="en" messages={messages}>
        <StyledMainContent>
          <WidgetContainer />
        </StyledMainContent>
      </IntlProvider>
    </>
  );
}
